module.exports = JSON.parse('{"About":"关于","Back to Viewer":"返回视图","INVESTIGATIONAL USE ONLY":"研究用途","Options":"选项","Preferences":"偏好","Study list":"研究列表"}')